<template>
  <div class="gs-app gm-suppression-table pb-4">
    <div class="gm-suppression-table__surface gs-refresh-controls flex mb-4">
      <div class="w-full">
        <server-table
          class="text-center groovemail-camplainers-table"
          :url="complainersUrl"
          ref="serverTable"
          :tableRef="'complainersTable'"
          :slotData="complainersTableSlotData"
          :tableColumns="complainersTableColumns"
          :tableOptions="complainersTableOptions"
          :tableTitle="'frontend_groovemail_components_suppressions_complainers'"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </div>
    </div>

    <!-- Confirmation move modal -->
    <confirm-modal
      :ref="`confirmation-move-complainers`"
      :name="`confirmation-move-complainers`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_suppressions_move_complainers_to_supressions')"
      @confirm="moveToSuppressions"
      @close="closeDeleteComplainersModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { postData } from '@/utils/apiHelper.js';
import { suppressorsUrl } from '@/utils/urls.js';
import monthsMixin from '@/mixin/monthsMixin';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';


let self;

export default {
  mixins: [monthsMixin, demoModeValuesMixin],

  data() {
    return {
      tableKey: 1,
      complainersUrl: suppressorsUrl.complainers,
      complainersTableColumns: ['email', 'complained_on', 'actions'],
      complainersTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['email'],
        sortable: ['email', 'complained_on'],
        headings: {
          email: () =>
            this.$t('frontend_groovemail_components_suppressions_complainers_email_header'),
          complained_on: () =>
            this.$t('frontend_groovemail_components_suppressions_complainers_complained_on_header'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        requestFunction(data) {
          const self = this;
          return axios
            .get(self.url, {
              params: data,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },

      complainer: null,
    };
  },

  created(){
    self = this;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.complainersTable.refresh();
    },
  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader (){
      this.$emit('hideLoader');
    },


    // open move Complainers modal
    async openDeleteComplainersModal(complainer) {
      // set the Complainers
      this.complainer = complainer;

      // open the modal
      this.$refs[`confirmation-move-complainers`].open();
    },

    // close move Complainers modal
    closeDeleteComplainersModal() {
      // reset the Complainers id
      this.complainer = null;

      // close the modal
      this.$refs[`confirmation-move-complainers`].close();
    },

    // move to suppressions
    async moveToSuppressions() {
      try {
        await postData(suppressorsUrl.addComplainers,{
          lead_id: this.complainer.lead_id,
          email: this.complainer.email,
        });

        this.$refs.serverTable.$refs.complainersTable.refresh();

      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },

  components: {
    ServerTable,
  },

  computed: {
    /**
     * Returns complainers table slot data.
     * @return {array} - slot data for complainer table 
     */
    complainersTableSlotData() {
      return [
        {
          slotName: 'complained_on',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.complained_on
              ? `${new Date(props.row.complained_on).getDate()} ${
                  this.months[new Date(props.row.complained_on).getMonth()]
                }, ${new Date(props.row.complained_on).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: (props) => {
            return {
              outerDiv: props.row.is_suppression ? 'cursor-not-allowed' : '',
              dropdown: props.row.is_suppression
                ? 'opacity-50 pointer-events-none'
                : '',
              outerSpan: props.row.is_suppression ? 'bg-grey-300' : '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => `${this.$t(
                'frontend_groovemail_components_suppressions_add_to'
              )} ${this.$t(
                'frontend_groovemail_suppressions_route_page_title'
              )}`,
              conditions: () => {
                return true;
              },
              callback: (props) => this.openDeleteComplainersModal(props.row),
            },
          ],
        },
      ];
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
  },
};
</script>

<style scoped>
.gm-suppression-table__surface {
  min-width: 0;
  padding: 20px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-suppression-table__surface {
    padding: 14px;
    border-radius: var(--gs-radius-md);
  }
}
</style>
